// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__3lXdf","title":"recipe_title__1jxna","img":"recipe_img__Y-HMR","calories":"recipe_calories__m0-7H"};